/** The API's `detail` (a string or a list of validation errors), or the status line. */
export async function responseDetail(response: Response): Promise<string> {
  try {
    const body = (await response.json()) as { detail?: unknown };
    const detail = body.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
      return detail
        .map(d => {
          const e = d as { loc?: unknown[]; msg?: string };
          const loc = Array.isArray(e.loc) ? e.loc.slice(1).join('.') : '';
          return loc ? `${loc}: ${e.msg ?? ''}` : (e.msg ?? JSON.stringify(d));
        })
        .join('; ');
    }
  } catch {
    // not JSON
  }
  return response.statusText || 'no details';
}
